import { Alert, Snackbar } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ConfirmAddSociete from "../../../ui/ConfirmAddSociete";
import UploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import SocieteAndUserService from "../../../services/societeAndUser";
import { useNavigate } from "react-router-dom";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import withLoader from "../../../components/layouts/WithLoader";

const theSocieteIs = [
  { label: " ", value: " " },
  { label: "FOURNISSEUR", value: "Fournisseur" },
  { label: "CLIENT", value: "Client B2B" },
    { label: "CLIENTPass", value: "Client passager" },

];

const codeCategorie = [
  { id: "1", value: "P" },
  { id: "2", value: "M" },
  { id: "3", value: "C" },
];

const type = [
  { id: "1", value: "Personne physique" },
  { id: "2", value: "Personne morale" },
];

const typeTVA = [
  { id: "NORMAL", value: "Normale" },
  { id: "EXPORTATRICE", value: "Exportatrice" },
];
const typeSoceite = [{ id: "PARTNER", value: "Partenaire" }];
const AddClientSociete = ({startLoading,stopLoading}) => {
  const navigate = useNavigate();
  const [showElement, setShowElement] = useState(
    JSON.parse(localStorage.getItem("status"))
  );

  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [societeTitle, setSocieteTitle] = useState("");
  const [societeMatricule, setSocieteMatricule] = useState("");
  const [societeAdress, setSocieteAdress] = useState("");
  const [societeTVACode, setSocieteTVACode] = useState("A");
  const [societeTimbre, setSocieteTimbre] = useState(0);
  const [societeTVAValue, setSocieteTVAValue] = useState(0);
  const [societeNumberEtabSecondaire, setSocieteNumberEtabSecondaire] =
    useState("000");
  const [societeEmail, setSocieteEmail] = useState("");
  const [societeCode, setSocieteCode] = useState("");
  const [societePhoneNumbre, setSocietePhoneNumbre] = useState("");

  const [societeLabel, setSocieteLabel] = useState(" ");
  const [codeCategorieValue, setCodeCategorieValue] = useState("P");
  const [typeSocieteFinal, setTypeSocieteFinal] = useState("Personne physique");
  const [isCancel, setIsCancel] = useState(false);

  const [societeCodeCategorieName, setSocieteCodeCategorieName] = useState("");
  const [societeCodeCategories, setSocieteCodeCategories] =
    useState(codeCategorie);
  const inputC = useRef(null);

  const [societeTypeName, setSocieteTypeName] = useState("");
  const [societeTypes, setSocieteTypes] = useState(type);
  const soceiteTypeRef = useRef(null);

  const [societeTypeNameTwo, setSocieteTypeNameTwo] = useState("");
  const [societeTypesTwo, setSocieteTypesTwo] = useState(typeSoceite);
  const soceiteTypeTwoRef = useRef(null);

  const [societeTypeTvaName, setSocieteTypeTvaName] = useState("Normale");
  const [societeTypesTva, setSocieteTypesTva] = useState(typeTVA);
  const soceiteTypeTVARef = useRef(null);

  const inputTvaValueRef = useRef(null);

  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();

  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("Choisir une image");
  const [fileDataURL, setFileDataURL] = useState(null);
  const [onConfirmAddSociete, setOnConfirmAddSociete] = useState(false);
  const [confirmSocieteModel, setConfirmSocieteModel] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  useEffect(() => {
    if(showElement.includes("USER_B2B")){
      setSocieteLabel("CLIENT")
    }
  }, []);
  useEffect(() => {
    let fileReader,
      isCancel = false;
    if (file) {
      fileReader = new FileReader();
      fileReader.onload = (e) => {
        const { result } = e.target;
        if (result && !isCancel) {
          setFileDataURL(result);
        }
      };
      fileReader.readAsDataURL(file);
    }
    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    };
  }, [file]);

  const changeCodeCategorie = (event) => {
    let codeCategorieElem = event.target.value;

    setSocieteCodeCategorieName({ codeCategorieElem });
  };

  const changeTypeTVA = (event) => {
    let typeTvaElement = event.target.value;

    if (event.target.value === "Exportatrice") {
      inputTvaValueRef.current.value = 0;
      inputTvaValueRef.current.disabled = true;
      setSocieteTVAValue(0);
    } else {
      inputTvaValueRef.current.disabled = false;
    }

    setSocieteTypeTvaName({ typeTvaElement });
  };

  const changeSocieteType = (event) => {
    let typeElement = event.target.value;

    setSocieteTypeName({ typeElement });
  };

  const changeSocieteTypeTwo = (event) => {
    let typeElement = event.target.value;

    if (
      event.target.value === "Partenaire" &&
      societeTypeTvaName.typeTvaElement === "Exportatrice"
    ) {
      inputTvaValueRef.current.value = 0;
      inputTvaValueRef.current.disabled = true;
      setSocieteTVAValue(0);
    } else {
      inputTvaValueRef.current.disabled = false;
    }
    //here Partenaire

    setSocieteTypeNameTwo({ typeElement });
  };

  const initializeCodeCategorie = () => {
    setSocieteCodeCategorieName("");
    inputC.current.value = "";
  };

  const initializeTypeTva = () => {
    setSocieteTypeTvaName("");
    soceiteTypeTVARef.current.value = "";
  };

  const initializeSocieteType = () => {
    setSocieteTypeName("");
    soceiteTypeRef.current.value = "";
  };

  const initializeSocieteTypeTwo = () => {
    setSocieteTypeNameTwo("");
    soceiteTypeTwoRef.current.value = "";
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeSocieteTitle = (event) => {
    setSocieteTitle(event.target.value);
  };

  const onChangeSocieteMatricule = (event) => {
    setSocieteMatricule(event.target.value);
  };

  const onChangeSocieteAdress = (event) => {
    setSocieteAdress(event.target.value);
  };

  const onChangeSocieteTVACode = (event) => {
    setSocieteTVACode(event.target.value);
  };

  const onChangeSocieteCategorieCode = (event) => {
    setCodeCategorieValue(event.target.value);
  };

  const onChangeSocieteEmail = (event) => {
    setSocieteEmail(event.target.value);
  };
  const onChangeSocieteCode = (event) => {
    setSocieteCode(event.target.value);
  };
  const onChangeSocietePhoneNumber = (event) => {
    setSocietePhoneNumbre(event.target.value);
  };

  const onChangeSocieteNumberEtabSecondaire = (event) => {
    setSocieteNumberEtabSecondaire(event.target.value);
  };

  const onChangeSocieteTimbre = (event) => {
    setSocieteTimbre(event.target.value);
  };

  const onChangeSocieteTvaValue = (event) => {
    setSocieteTVAValue(event.target.value);
  };

  const onUploadImageHandler = (e) => {
    if (e.target.files[0].size > 2097152) {
      setOpenInfoAlert(true);
      setInfoAlertText("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      const file = e.target.files[0];

      setFile(file);
      setFileName(e.target.files[0].name);
    }
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const onConfirmAddSocieteHandler = () => {
    // console.log(societeTypeName.typeElement);
    if (societeLabel === "") {
      setErrorAlertText("Erreur :le premier champ est vide ! ");
      setOpenErrorAlert(true);
    } else if (societeTitle === "") {
      setErrorAlertText("Erreur :le champ titre  est vide ! ");
      setOpenErrorAlert(true);
    } else if (societeMatricule === "") {
      setErrorAlertText("Erreur :le champ matricule  est vide ! ");
      setOpenErrorAlert(true);
    } else if (societeNumberEtabSecondaire === "") {
      setErrorAlertText(
        "Erreur :le champ  nombre d'établissements secondaires  est vide ! "
      );
      setOpenErrorAlert(true);
    } else if (societeEmail === "") {
      setErrorAlertText("Erreur :le champ email est vide ! ");
      setOpenErrorAlert(true);
    } else if (societePhoneNumbre === "") {
      setErrorAlertText("Erreur :le champ télephone est vide ! ");
      setOpenErrorAlert(true);
    } else if (societeAdress === "") {
      setErrorAlertText("Erreur :le champ adresse est vide ! ");
      setOpenErrorAlert(true);
    } else if (societeTVACode === "") {
      setErrorAlertText("Erreur :le champ code TVA   est vide ! ");
      setOpenErrorAlert(true);
    } else if (
      societeTypeTvaName.typeTvaElement === "" ||
      (societeTypeTvaName.typeTvaElement === "") === undefined
    ) {
      setErrorAlertText("Erreur :le champ type de TVA  est vide ! ");
      setOpenErrorAlert(true);
    } else if (societeTVAValue < 0) {
      setErrorAlertText("Erreur :le champ type de TVA ( % )  est vide ! ");
      setOpenErrorAlert(true);
    } else {


      let confirmModel;
       if (societeLabel === "CLIENTPass"){
         confirmModel = {
        title: societeTitle,
        matricule: societeMatricule,
        adresse: societeAdress,
        idUserCreation: getCurrentUserId(),
        typeSociete:"P",
        codeTVA: "A",
        codeCategorie: "M",
        numberEtabSecondaire: societeNumberEtabSecondaire,
        email: societeEmail,
        code: societeCode.trim(),
        numPhone: societePhoneNumbre,
        typeTVA:  "Normale",
        timbre: 1,
        tva: "0",
        typeClient: "CLIENT",
        file: file,
      };
       }else{
         confirmModel = {
        title: societeTitle,
        matricule: societeMatricule,
        adresse: societeAdress,
        idUserCreation: getCurrentUserId(),
        typeSociete: codeCategorieValue,
        codeTVA: societeTVACode,
        codeCategorie: codeCategorieValue,
        numberEtabSecondaire: societeNumberEtabSecondaire,
        email: societeEmail,
        code: societeCode.trim(),
        numPhone: societePhoneNumbre,
        typeTVA: societeTypeTvaName.typeTvaElement,
        timbre: societeTimbre,
        tva: societeTVAValue,
        typeClient: societeLabel,
        file: file,
      };
       }
      if (file != null) {

        const uploadData = new FormData();
        uploadData.append("picture", file);
        startLoading();
        UploadAndDownloadService.uploadFile(
          "/retail/uploadFile/uploadFile/SocietePicture",
          uploadData
        )
          .then((response) => {
            if (Object.keys(response.data)[0] === "success") {
              confirmModel.fileUrl = response.data.success;
              SocieteAndUserService.addSociete(confirmModel)
                .then((res) => {
                  if (Object.keys(res.data)[0] === "societeSuccess") {
                    setOpenSuccessAlert(true);
                    setSuccessAlertText("Enregistrement avec succées");
                    setTimeout(() => {
                      navigate(`/tiers`);
                    }, 2000);
                  }
                })
                .catch(() => {
                  setOpenErrorAlert(true);
                  setErrorAlertText("Erreur : il ya un probléme de connection");
                });
            } else {
              setOpenErrorAlert(true);
              setErrorAlertText("Erreur : il ya un erreur  ");
            }
          })
          .catch(() => {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un probléme de connection");
          }).finally(()=>{
            stopLoading()
          });
      }else{
        startLoading();
        SocieteAndUserService.addSociete(confirmModel)
        .then((res) => {
          if (Object.keys(res.data)[0] === "societeSuccess") {
            setOpenSuccessAlert(true);
            setSuccessAlertText("Enregistrement avec succées");
            setTimeout(() => {
              navigate(`/tiers`);
            }, 2000);
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        }).finally(()=>{
            stopLoading()
          });
      }
    }
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const chooseSociete = () => {
    console.log(societeLabel);

    if (societeLabel === "FOURNISSEUR") {
      return (
        <>
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Titre:</label>
                <input
                  placeholder="Ajouter titre "
                  onChange={onChangeSocieteTitle}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Matricule: <span style={{color:"red"}}>(7 chiffres / lettres)</span></label>
                <input
                  placeholder="Ajouter matricule "
                  onChange={onChangeSocieteMatricule}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">
                  Nombre d'établissements secondaires: <span style={{color:"red"}}>(3 chiffres)</span>
                </label>
                <input
                  placeholder="Ajouter..."
                  onChange={onChangeSocieteNumberEtabSecondaire}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Timbre:</label>
                <input
                  defaultValue={societeTimbre}
                  onChange={onChangeSocieteTimbre}
                  type="number"
                  min="0"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Email:</label>
                <input
                  placeholder="Ajouter email "
                  onChange={onChangeSocieteEmail}
                  type="email"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="societeCode">Code (facultatif):</label>
                <input
                  placeholder="Ajouter code "
                  onChange={onChangeSocieteCode}
                  type="text"
                  id="societeCode"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Télephone:</label>
                <input
                  placeholder="Ajouter Télephone"
                  onChange={onChangeSocietePhoneNumber}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Adresse:</label>
                <input
                  placeholder="Ajouter adresse "
                  onChange={onChangeSocieteAdress}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <div>
                  <label>Code de catégorie: <span style={{color:"red"}}>(M , P , C ...)</span></label>

                  <input
                  placeholder="Ajouter code Categorie "
                  onChange={onChangeSocieteCategorieCode}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
                  {/* <select
                    value={codeCategorieValue || null}
                    onChange={(e) => setCodeCategorieValue(e.target.value)}
                    className="form-control select2"
                    style={{ width: "100%" }}
                  >
                    {codeCategorie.map((element, index) => (
                      <option key={element.id} value={element.value}>
                        {element.value}
                      </option>
                    ))}
                  </select> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              {codeCategorieValue === "C" && (
                <div className="form-group">
                  <div>
                    <label>Type de société: </label>
                    <select
                      value={typeSocieteFinal || null}
                      onChange={(e) => setTypeSocieteFinal(e.target.value)}
                      className="form-control select2"
                      style={{ width: "100%" }}
                    >
                      {type.map((element, index) => (
                        <option key={element.id} value={element.value}>
                          {element.value}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Code TVA:<span style={{color:"red"}}> (Exemple: A, B ..)</span></label>
                <input
                  placeholder="Ajouter code TVA "
                  onChange={onChangeSocieteTVACode}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label>Société: </label>
                <input
                  class="form-control"
                  data-value={societeTypeTvaName?.value}
                  value={societeTypeTvaName?.value}
                  type="text"
                  list="dataFour"
                  ref={soceiteTypeTVARef}
                  onChange={changeTypeTVA}
                  onClick={initializeTypeTva}
                />

                <datalist id="dataFour">
                  {societeTypesTva.map((typeTvaElem, index) => (
                    <option key={index} value={typeTvaElem.value}></option>
                  ))}
                </datalist>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">TVA {"( % )"}:</label>
                <input
                  defaultValue={societeTVAValue}
                  onChange={onChangeSocieteTvaValue}
                  type="number"
                  ref={inputTvaValueRef}
                  min="0"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <div
                  class="input-group  sm-white border"
                  style={{ marginTop: 100 }}
                >
                  <input
                    id="upload"
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    className="form-control border-0"
                    onChange={onUploadImageHandler}
                  />

                  <label
                    id="upload-label"
                    for="upload"
                    class="font-weight-light text-muted"
                  >
                    {fileName}
                  </label>
                  <div class="input-group-append">
                    <label
                      for="upload"
                      class="btn btn-light m-0 rounded-pill px-4"
                    >
                      {" "}
                      <i class="fa fa-cloud-upload mr-2 text-muted"></i>
                      <small class="text-uppercase font-weight-bold text-muted">
                        Choisir une image
                      </small>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <div
                  class="image-area"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    verticalAlign: "middle",
                  }}
                >
                  {fileDataURL ? (
                    <img
                      id="imageResult"
                      src={fileDataURL}
                      alt
                      style={{ height: 197, width: 620 }}
                      className="img-fluid rounded shadow-sm mx-auto d-block"
                    />
                  ) : (
                    <img
                      style={{ marginTop: 180 }}
                      id="imageResult"
                      src="#"
                      alt
                      className="img-fluid rounded shadow-sm mx-auto d-block"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      );
    } else if (societeLabel === "CLIENT") {
      return (
        <>
          {" "}
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Titre client:</label>
                <input
                  placeholder="Ajouter titre "
                  onChange={onChangeSocieteTitle}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Matricule: <span style={{color:"red"}}>(7 chiffres / lettres)</span></label>
                <input
                  placeholder="Ajouter matricule "
                  onChange={onChangeSocieteMatricule}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">
                  Nombre d'établissements secondaires:<span style={{color:"red"}}>(3 chiffres)</span>
                </label>
                <input
                  placeholder="Ajouter..."
                  onChange={onChangeSocieteNumberEtabSecondaire}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Timbre:</label>
                <input
                  defaultValue={societeTimbre}
                  onChange={onChangeSocieteTimbre}
                  type="number"
                  min="0"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Email:</label>
                <input
                  placeholder="Ajouter email "
                  onChange={onChangeSocieteEmail}
                  type="email"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="societeCode">Code (facultatif):</label>
                <input
                  placeholder="Ajouter code "
                  onChange={onChangeSocieteCode}
                  type="text"
                  id="societeCode"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Télephone:</label>
                <input
                  placeholder="Ajouter Télephone"
                  onChange={onChangeSocietePhoneNumber}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Adresse:</label>
                <input
                  placeholder="Ajouter adresse "
                  onChange={onChangeSocieteAdress}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <div>
                  <label>Code de catégorie:<span style={{color:"red"}}>(M, P, C...)</span> </label>
                  <input
                  placeholder="Ajouter code Categorie "
                  onChange={onChangeSocieteCategorieCode}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
                  {/* <select
                    value={codeCategorieValue || null}
                    onChange={(e) => setCodeCategorieValue(e.target.value)}
                    className="form-control select2"
                    style={{ width: "100%" }}
                  >
                    {codeCategorie.map((element, index) => (
                      <option key={element.id} value={element.value}>
                        {element.value}
                      </option>
                    ))}
                  </select> */}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              {codeCategorieValue === "C" && (
                <div className="form-group">
                  <div>
                    <label>Type de société: </label>
                    <select
                      value={typeSocieteFinal || null}
                      onChange={(e) => setTypeSocieteFinal(e.target.value)}
                      className="form-control select2"
                      style={{ width: "100%" }}
                    >
                      {type.map((element, index) => (
                        <option key={element.id} value={element.value}>
                          {element.value}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Code TVA:<span style={{color:"red"}}> (Exemple: A, B ..)</span></label>
                <input
                  placeholder="Ajouter code TVA "
                  onChange={onChangeSocieteTVACode}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label>Société: </label>
                <input
                  class="form-control"
                  data-value={societeTypeTvaName?.value}
                  value={societeTypeTvaName?.value}
                  type="text"
                  list="dataFour"
                  ref={soceiteTypeTVARef}
                  onChange={changeTypeTVA}
                  onClick={initializeTypeTva}
                />

                <datalist id="dataFour">
                  {societeTypesTva.map((typeTvaElem, index) => (
                    <option key={index} value={typeTvaElem.value}></option>
                  ))}
                </datalist>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">TVA {"( % )"}:</label>
                <input
                  defaultValue={societeTVAValue}
                  onChange={onChangeSocieteTvaValue}
                  type="number"
                  ref={inputTvaValueRef}
                  min="0"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <div
                  class="input-group  sm-white border"
                  style={{ marginTop: 100 }}
                >
                  <input
                    id="upload"
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    className="form-control border-0"
                    onChange={onUploadImageHandler}
                  />

                  <label
                    id="upload-label"
                    for="upload"
                    class="font-weight-light text-muted"
                  >
                    {fileName}
                  </label>
                  <div class="input-group-append">
                    <label
                      for="upload"
                      class="btn btn-light m-0 rounded-pill px-4"
                    >
                      {" "}
                      <i class="fa fa-cloud-upload mr-2 text-muted"></i>
                      <small class="text-uppercase font-weight-bold text-muted">
                        Choisir une image
                      </small>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <div
                  class="image-area"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    verticalAlign: "middle",
                  }}
                >
                  {fileDataURL ? (
                    <img
                      id="imageResult"
                      src={fileDataURL}
                      alt
                      style={{ height: 197, width: 620 }}
                      className="img-fluid rounded shadow-sm mx-auto d-block"
                    />
                  ) : (
                    <img
                      style={{ marginTop: 180 }}
                      id="imageResult"
                      src="#"
                      alt
                      className="img-fluid rounded shadow-sm mx-auto d-block"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      );
    } else if (societeLabel === "CLIENTPass") {
      return (
        <>
          {" "}
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Nom client:</label>
                <input
                  placeholder="Ajouter titre "
                  onChange={onChangeSocieteTitle}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">CIN: <span style={{color:"red"}}>(8 chiffres)</span></label>
                <input
                  placeholder="Ajouter matricule "
                  onChange={onChangeSocieteMatricule}
                  
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
                      <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Email:</label>
                <input
                  placeholder="Ajouter email "
                  onChange={onChangeSocieteEmail}
                  type="email"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
          </div>
       
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="societeCode">Code (facultatif):</label>
                <input
                  placeholder="Ajouter code "
                  onChange={onChangeSocieteCode}
                  type="text"
                  id="societeCode"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Télephone:</label>
                <input
                  placeholder="Ajouter Télephone"
                  onChange={onChangeSocietePhoneNumber}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Adresse:</label>
                <input
                  placeholder="Ajouter adresse "
                  onChange={onChangeSocieteAdress}
                  type="text"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div>
           
            {/* <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">TVA {"( % )"}:</label>
                <input
                  defaultValue={societeTVAValue}
                  onChange={onChangeSocieteTvaValue}
                  type="number"
                  ref={inputTvaValueRef}
                  min="0"
                  id="inputName"
                  className="form-control"
                />
              </div>
            </div> */}
          </div>
   
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <div
                  class="input-group  sm-white border"
                  style={{ marginTop: 100 }}
                >
                  <input
                    id="upload"
                    type="file"
                    accept=".jpg, .jpeg, .png"
                    className="form-control border-0"
                    onChange={onUploadImageHandler}
                  />

                  <label
                    id="upload-label"
                    for="upload"
                    class="font-weight-light text-muted"
                  >
                    {fileName}
                  </label>
                  <div class="input-group-append">
                    <label
                      for="upload"
                      class="btn btn-light m-0 rounded-pill px-4"
                    >
                      {" "}
                      <i class="fa fa-cloud-upload mr-2 text-muted"></i>
                      <small class="text-uppercase font-weight-bold text-muted">
                        Choisir une image
                      </small>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <div
                  class="image-area"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    verticalAlign: "middle",
                  }}
                >
                  {fileDataURL ? (
                    <img
                      id="imageResult"
                      src={fileDataURL}
                      alt
                      style={{ height: 197, width: 620 }}
                      className="img-fluid rounded shadow-sm mx-auto d-block"
                    />
                  ) : (
                    <img
                      style={{ marginTop: 180 }}
                      id="imageResult"
                      src="#"
                      alt
                      className="img-fluid rounded shadow-sm mx-auto d-block"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">Ajouter tiers</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-dark">
                <div className="card-header">
                  <h5 className="card-title"> Ajouter un tiers</h5>
                </div>
                <div className="card-body">
                  <div className="row" style={{ marginTop: 10 }}>
                    <div className="col-sm-12">
                      <div className="form-group">
                        {/* {showElement.includes("USER_B2B") && (
                          <>
                          <label>Ajouter client: </label>
                        </>
                        )} */}
                         {!showElement.includes("USER_B2B") && (
                          <>
                           <label>Choisir client ou fournisseur: </label>
                           <select
                          value={societeLabel || null}
                          onChange={(e) => setSocieteLabel(e.target.value)}
                          className="form-control select2"
                          style={{ width: "100%" }}
                        >
                          {theSocieteIs.map((element, index) => (
                            <option key={element.label} value={element.label}>
                              {element.value}
                            </option>
                          ))}
                        </select>
                        </>
                        )}
                      
                      </div>
                    </div>
                  </div>
                  {chooseSociete()}
                </div>
                <div class="card-footer">
                  <button
                    class="btn btn-dark float-right"
                    onClick={onConfirmAddSocieteHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="error">
          {infoAlertText}
        </Alert>
      </Snackbar>

      {/* {onConfirmAddSociete && (
        <ConfirmAddSociete
          setOnConfirmAddSociete={setOnConfirmAddSociete}
          confirmSocieteModel={confirmSocieteModel}
          setIsCancel={setIsCancel}
        />
      )} */}
    </div>
  );
};
export default withLoader(AddClientSociete);
